module.exports = window["MaterialUI"].ListItemIcon;